import _objectSpread from "@babel/runtime/helpers/objectSpread";

/**
 * Creates a function to create a redux action. Will automatically set the type
 * of the action and has support for setting custom properties on the action
 * object. The action type is always of the form:
 *  `'<verb>_<model>_<suffix>'.toUpperCase()`
 *
 * @param {Object} options The options for the creator function
 * @param {string} options.model The model to be used in the action type
 * @param {string} options.verb The verb to be used in the action type
 * @param {string} options.suffix The suffix to be used in the action type
 * @returns {Function} A newly created redux reducer
 *
 * @public
 * @author Connor Taylor
 * @example
 * const action = makePlainAction({
 *   model: `foo`,
 *   verb: `create`,
 *   suffix: `success`,
 * });
 *
 * dispatch(action({ foo: `bar` }));
 *
 * // Will dispatch this action:
 * {
 *   type: `CREATE_FOO_SUCCESS`,
 *   foo: `bar`,
 * }
 */
var makePlainAction = function makePlainAction(_ref) {
  var model = _ref.model,
      verb = _ref.verb,
      _ref$suffix = _ref.suffix,
      suffix = _ref$suffix === void 0 ? "" : _ref$suffix;
  var type = (verb + "_" + model + (suffix ? "_" + suffix : "")).toUpperCase();
  return function (args) {
    if (args === void 0) {
      args = {};
    }

    return _objectSpread({}, args, {
      type: type
    });
  };
};
/** @component */


export default makePlainAction;